var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M70.393,13.54l-57.133,97.6H120.378Z","transform":"translate(19.536 19.948)","fill":"none","key":0}),React.createElement("path",{"d":"M85.439,30.1h0l1.187-1.385,46.25,90.3L95.95,0H75.323L2.46,126.533Z","transform":"translate(3.624)","fill":"#5ac827","key":1}),React.createElement("path",{"d":"M78.207,4.19l37.915,123.194H18.65l110.531,17.758,12.416,1.929,9.126-15.977Z","transform":"translate(27.477 6.173)","fill":"#006837","key":2}),React.createElement("path",{"d":"M82.039,17,0,112.345,9.671,128.3H153.64l-125-20.083Z","transform":"translate(0 25.046)","fill":"#8cc63f","key":3})]));
}

Logo.defaultProps = {"viewBox":"0 0 178.2 153.344"};

module.exports = Logo;

Logo.default = Logo;
